/* eslint-disable jsx-a11y/mouse-events-have-key-events */

import * as React from 'react';
import { IconButton, Typography } from '@mui/material';
import { combine } from '../utils';

interface DayProps {
    filled?: boolean;
    outlined?: boolean;
    highlighted?: boolean;
    disabled?: boolean;
    startOfRange?: boolean;
    endOfRange?: boolean;
    onClick?: () => void;
    onHover?: () => void;
    value: number | string;
}

const Day: React.FunctionComponent<DayProps> = ({
    startOfRange,
    endOfRange,
    disabled,
    highlighted,
    outlined,
    filled,
    onClick,
    onHover,
    value,
}: DayProps) => (
    <div
        className={combine(
            'buttonContainer',
            startOfRange && 'leftBorderRadius',
            endOfRange && 'rightBorderRadius',
            !disabled && highlighted && 'highlighted-days'
        )}
    >
        <IconButton
            className={combine(
                'button-days',
                !disabled && outlined && 'outlined-days',
                !disabled && filled && 'filled-days'
            )}
            disabled={disabled}
            onClick={onClick}
            onMouseOver={onHover}
        >
            <Typography
                color={!disabled ? 'textPrimary' : 'textSecondary'}
                className={combine(
                    'buttonText-days',
                    !disabled && filled && 'contrast-days',
                    'numerical-days'
                )}
                variant="body2"
            >
                {value}
            </Typography>
        </IconButton>
    </div>
);

export default Day;
